if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        console.log('ProductForm');
        this.productInfo = this.closest('product-info');
        this.form = this.querySelector('form');
        if(this.form){
          this.form.querySelector('[name=id]').disabled = false;
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (this.productInfo) {
          this.quantity_input = this.productInfo.querySelector('.quantity__input');
          this.productScript = this.productInfo.querySelector('variant-radios script');
        } else {
          if(this.form) this.quantity_input = this.form.querySelector('.quantity__input');
          this.productScript = this.querySelector('.product-json');
        }

        this.productJson = {};
        if (this.productScript) {
          this.productJson = JSON.parse(this.productScript.innerHTML.trim());
        }

        if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const _this = this;
        
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        fetch(`${routes.cart_url}.json`)
          .then((response) => response.json())
          .then((response) => {
            _this.processAddToCart(evt, response);
          })
          .catch((e) => {
            console.error(e);
          });
      }

      processAddToCart(evt, data) {
        const _this = this;
        let hasFirstBag = 0;
        let selected_variant = null;
        let id = this.form.querySelector('[name=id]').value;
        const formData = new FormData();
        const quantity = this.quantity_input.value;
        
        this.productJson.variants.map((variant) => {
          if (variant.id == id) {
            selected_variant = variant;
          }
        });
        
        const option1 = selected_variant.option1;//.replace('(First Bag)', '').trim();
        
        data.items.map((item) => {
          if (item.id == selected_variant.id) {
            hasFirstBag = 1;
          }
        });
        
        if (hasFirstBag) {
          this.productJson.variants.map((variant) => {
            if (variant.option2 == 'OTP' && option1 == variant.option1) {
              id = variant.id;
            }
          });
        }
        
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        formData.append('quantity', quantity);
        formData.append('id', id);
        this.addToCart(evt, formData);
        
        /*
        if (quantity > 1) {
          formData.set('quantity', 1);  
          
          let formDataFields = {};
          formData.forEach(function(value, key){
            formDataFields[key] = value;
          });
          
          let option1 = formDataFields['Flavor'].replace('(First Bag)', '').trim();
          let items = [];
          let additionVariantId = 0;
          this.productJson.map(function(variant){
            if (variant.option1 == option1) {
              additionVariantId = variant.id;
            }
          });

          items.push({ 'id': additionVariantId, 'quantity': quantity - 1 });
          let additionalFormData = {
           'items': items
          };
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(additionalFormData)
          })
          .then(response => {
            _this.clearToCart(evt, formData);
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        } else {
          _this.clearToCart(evt, formData);
        }*/
      }

      clearToCart(evt, formData) {
        const _this = this;
        fetch(window.Shopify.routes.root + 'cart/clear.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(response => {
          _this.addToCart(evt, formData);
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      }

      addToCart(evt, formData) {
        const _this = this;
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            //window.location = '/checkout/';
            //return;
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
